// Mirrors Initiator/Models/Participant.cs, camel-cased by the JSON serialiser.
interface Participant {
    role: Role;
    name: string;
    nameSluggified: string;
    primaryHexColor: string;
    secondaryHexColor: string;
    initiative: number;
    initiativeLocked: boolean;
    hitPoints: number | null;
    maxHitPoints: number | null;
    experiencePoints: number | null;
    armorPoints: number | null;
    conditions: Condition[];
    isDead: boolean;
    enemies: Enemy[];
}
